<template>
  <f7-page no-swipeback @page:init="init">
    <f7-navbar title="訂單詳情 Order Info" back-link="返回 Back"></f7-navbar>

    <f7-list media-list v-if="this.categories_products && this.categories_products.length > 0">
      <f7-list-item
        title="狀態 STATUS"
        :subtitle="this.order_data.status"
      ></f7-list-item>

      <f7-list-item
        title="訂單日期 ORDER DATE"
        :subtitle="this.order_data.created_at"
      ></f7-list-item>

      <f7-list-item
        title="用戶 USER"
        :subtitle="this.order_data.user.name"
      ></f7-list-item>

      <f7-list-item
        title="工場 Warehouse"
        :subtitle="this.order_data.store.name"
      ></f7-list-item>

      <f7-list-item
        title="備註 REMARKS"
        :subtitle="this.order_data.remark"
      ></f7-list-item>

      <f7-list-group :key="category_index" v-for="(category, category_index) in categories_products">
        <f7-list-item :title="category.category_name" group-title></f7-list-item>
        <f7-list-item
          v-for="(product, i) in category.products"
          :key="i"
          :title="product.name"
          class="text-orange"
        >
          <list-product-item
            :product="product"
            :modified="product.quantity != product.original_quantity"
            :readonly="true"
          />
        </f7-list-item>
      </f7-list-group>

      <f7-list-group v-if="missing_products.length > 0">
        <f7-list-item title="工場備註 Warehouse Remarks" group-title></f7-list-item>
        <f7-list-item v-for="product in missing_products" :key="product.id" :title="`${product.name} 欠Missing ${product.difference} 件Unit`"></f7-list-item>
      </f7-list-group>
    </f7-list>

    <f7-toolbar position="bottom" v-if="this.categories_products && this.categories_products.length > 0">
      <div class="bottom-overview">
        {{ order_data.products.length }} 項 Items，{{ provideTotalQuantity }} 件 Units，合計 Total ${{ displaySubtotal }}
      </div>
    </f7-toolbar>
  </f7-page>
</template>

<script>
import ListProductItem from './ListProductItem.vue'
import { format, parseISO } from 'date-fns'
import axios from 'axios'

export default {
  components: {
    ListProductItem,
  },

  props: {
    orderId: String,
  },

  data: () => ({
    order_data: {},
    categories_products: [],
  }),

  computed: {
    displaySubtotal() {
      if (! this.order_data.products) {
        return 0;
      }

      const total = this.order_data.products.reduce((total, orderProduct) => {
        const isSupplyConfirmed = orderProduct.supply_confirmed_at != null
        const quantity = (isSupplyConfirmed ? orderProduct.supply_quantity : orderProduct.quantity)

        return total + (quantity * orderProduct.price / 100)
      }, 0)

      return Math.round(total * 10) / 10
    },
    missing_products() {
      let missing_products = []

      for (let i = 0; i < this.categories_products.length; i++) {
        for (let j = 0; j < this.categories_products[i].products.length; j++) {
          let product = this.categories_products[i].products[j]

          if (product.quantity != product.original_quantity) {
            missing_products.push({
              id: product.id,
              name: product.name,
              category_id: this.categories_products[i].category_id,
              difference: product.original_quantity - product.quantity,
              supply_quantity: product.quantity,
              supply_subtotal: product.quantity * product.price,
            })
          }
        }
      }

      return missing_products
    },
    provideTotalQuantity() {
      if (! this.order_data.products) {
        return 0;
      }
      return this.order_data.products.reduce((total, orderProduct) => {
        const isSupplyConfirmed = orderProduct.supply_confirmed_at != null
        return total + (isSupplyConfirmed ? orderProduct.supply_quantity : orderProduct.quantity)
      }, 0)
    }
  },

  methods: {
    init() {
      this.fetchOrder()
    },
    fetchOrder() {
      axios.get(`/api/orders/${this.orderId}`)
        .then(({ data }) => {
          let categoryIds = [...new Set(data.products.map(product => product.category.id))]

          let structured = categoryIds.map((categoryId) => {
            let findCategory = data.products.find(product => product.category.id === categoryId)

            return {
              category_id: categoryId,
              category_name: findCategory.category.name,
              sorting: findCategory.category.category_sorting || 0,  
              products: data.products
                .filter(product => (product.category.id === categoryId))
                .map(product => {
                  let isSupplyConfirmed = product.supply_confirmed_at != null

                  return {
                    id: product.id,
                    name: product.product_name,
                    subname: product.product_subname,
                    quantity: isSupplyConfirmed ? product.supply_quantity : product.quantity,
                    original_quantity: product.quantity,
                    price: product.price / 100,
                    expired_date: product.expired_date,
                    features: [] // product.properties
                  }
                })
            }
          })

          // Sort categories by sorting value in descending order
          structured.sort((a, b) => (b.sorting || 0) - (a.sorting || 0))

          data.created_at = format(parseISO(data.created_at), 'yyyy-MM-dd HH:mm')

          this.categories_products = structured
          this.order_data = data
        })
    }
  }
}
</script>
